import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/authContext';
import styles from './EditProfilePage.module.css';
import apiRequest from '../../lib/apiRequest';
import logger from '../../lib/logger';

const EditProfilePage = () => {
  const { user, login, updateUser } = useContext(AuthContext);
  const navigate = useNavigate();

  // Local state for username and email. Email is read-only.
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [updateMessage, setUpdateMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  // Pre-populate fields with current user info
  useEffect(() => {
    if (user) {
        logger.log(user)
      setUsername(user.username || '');
      setEmail(user.email || '');
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setUpdateMessage('');
    setErrorMessage('');
    setLoading(true);
    try {
      // PATCH request to update user profile (only username is updated)
      const res = await apiRequest.patch(
        '/users/profile',
        { username } // Only update username
      );
      if (res.data.success) {
        setUpdateMessage('Profile updated successfully!');
        // Optionally update context with the new user info
        updateUser({ ...user, username: res.data.user.username });
        // Redirect after a short delay

        setTimeout(() => {
          navigate('/profile/' + res.data.user._id);
        }, 1500);
      } else {
        setErrorMessage(res.data.message || 'Failed to update profile.');
      }
    } catch (error) {
      logger.error('Error updating profile:', error);
      setErrorMessage(error.response?.data?.message || 'Error updating profile.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.editContainer}>
      <h2 className={styles.editTitle}>Edit Profile</h2>
      {updateMessage && <div className={styles.successMessage}>{updateMessage}</div>}
      {errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}
      <form onSubmit={handleSubmit} className={styles.editForm}>
        <label htmlFor="username" className={styles.label}>Username</label>
        <input
          id="username"
          name="username"
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className={styles.input}
          required
        />

        <label htmlFor="email" className={styles.label}>Email</label>
        <input
          id="email"
          name="email"
          type="email"
          value={email}
          disabled
          className={styles.input}
        />

        <button type="submit" className={styles.submitButton} disabled={loading}>
          {loading ? 'Updating...' : 'Update Profile'}
        </button>
      </form>
    </div>
  );
};

export default EditProfilePage;
